<template>
    <div v-if="quest" class="outer-box">
        <div class="popup-card">
            <img :src="getImage(quest)" alt="Quest image" class="popup-image">
            <div class="content-column">
                <h5 class="title">{{ quest.title }}</h5>
                <p v-dompurify-html="quest.content" class="description">
                    {{ quest.content }}
                </p>
                <div class="progress-container">
                    <div class="progress-bar-bg">
                        <div
                            :style="{ width: barWidth }"
                            class="progress-bar-fill"
                        />
                    </div>
                    <span class="progress-text">
                        {{ progress }} / {{ quest.maxLimit }}
                    </span>
                </div>
            </div>
        </div>

        <button class="ok-button" @click="submitQuest">
            OK
        </button>
    </div>
</template>

<script>
    import taskUtil from '@/utils/task-util'

    export default {
        name: 'ActionQuest',
        components: {},
        data() {
            return {
                quest: null
            }
        },
        computed: {
            mission() {
                return this.$store.getters.getMission(
                    parseInt(this.$route.params.missionId, 10)
                )
            },
            task() {
                const missionId = parseInt(this.$route.params.missionId, 10)
                const taskId = parseInt(this.$route.params.taskId, 10)
                return this.$store.getters.getTask(missionId, taskId)
            },
            barWidth() {
                const pct = (this.progress / this.quest.maxLimit) * 100
                return `${Math.min(Math.max(pct, 0), 100)}%`
            },
            progress() {
                return this.$store.getters.getCurrentProgress(this.quest.id)
            }
        },

        mounted() {
            this.quest = this.task.quest
            this.$store.commit('setQuest', { id: this.quest.id, maxLimit: this.quest.maxLimit })
            this.$store.commit('setCurrentProgress', { id: this.quest.id, percent: 15 })
        },
        methods: {
            submitQuest() {
                const maxPoints = this.task.points
                const finished = true
                taskUtil.updateTask(
                    this.mission,
                    this.task,
                    maxPoints,
                    finished,
                    this.$router
                )
            },
            getImage(quest) {
                return quest?.imageUrl
            }
        }
    }
</script>

<style scoped>
.outer-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background-color: rgb(30 60 100 / 80%);
    border-radius: 20px;
    max-width: 600px;
    width: 90%;
    margin: 0 auto;
    padding: 2rem;
}

.popup-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    background-color: #5c91d3;
    border-radius: 20px;
    padding: 25px;
    width: 100%;
    box-shadow: 0 10px 20px rgb(0 0 0 / 20%);
}

.header-row {
    display: flex;
    gap: 1rem;
}

.popup-image {
    width: 120px;
    height: auto;
    object-fit: cover;
}

.content-column {
    display: flex;
    flex-direction: column;
    flex: 1;
    color: #fff;
}

.title {
    font-weight: bold;
}

.progress-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    position: relative;
}

.progress-bar-bg {
    background-color: #0f2545;
    border-radius: 13px;
    width: 100%;
    height: 20px;
    overflow: hidden;
}

.progress-bar-fill {
    background-color: #1270f9;
    height: 100%;
}

.progress-text {
    color: #fff;
    font-weight: bold;
    font-size: 0.9rem;
    white-space: nowrap;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.ok-button {
    background-color: #1270f9;
    border: none;
    border-radius: 6px;
    color: var(--white);
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    max-width: 120px;
    width: 100%;
    height: 40px;
    display: grid;
    place-items: center;
    font-size: 1.1rem;
    letter-spacing: 0.1em;
}

.ok-button:active {
    transform: scale(0.9);
}

.ok-button:hover {
    background-color: #0e5ec1;
}

@media screen and (min-width: 768px) {
    .outer-box {
        gap: 1.5rem;
        border-radius: 40px;
        max-width: 1015px;
        width: 100%;
        padding: 78px 90px 30px;
    }

    .popup-card {
        flex-direction: row;
        align-items: unset;
        gap: 1.5rem;
        border-radius: 40px;
        padding: 35px;
        height: 100%;
    }

    .popup-image {
        width: 215px;
    }

    .content-column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
    }

    .progress-bar-bg {
        height: 26px;
    }

    .progress-text {
        font-size: 1.15rem;
    }

    .title {
        font-size: 2rem;
    }
}
</style>
